const whiteList = {
  a: ["title", "class", "style", "href"],
  abbr: ["title", "class", "style"],
  address: ["class", "style"],
  area: ["shape", "coords", "alt", "class", "style"],
  article: ["class", "style"],
  aside: ["class", "style"],
  b: ["class", "style"],
  bdi: ["dir", "class", "style"],
  bdo: ["dir", "class", "style"],
  big: ["class", "style"],
  blockquote: ["cite", "class", "style"],
  br: ["class", "style"],
  caption: ["class", "style"],
  center: ["class", "style"],
  cite: ["class", "style"],
  code: ["class", "style"],
  col: ["align", "valign", "span", "width", "class", "style"],
  colgroup: ["align", "valign", "span", "width", "class", "style"],
  dd: ["class", "style"],
  del: ["datetime", "class", "style"],
  details: ["open", "class", "style"],
  div: ["class", "style"],
  dl: ["class", "style"],
  dt: ["class", "style"],
  em: ["class", "style"],
  font: ["color", "size", "face", "class", "style"],
  footer: ["class", "style"],
  h1: ["class", "style"],
  h2: ["class", "style"],
  h3: ["class", "style"],
  h4: ["class", "style"],
  h5: ["class", "style"],
  h6: ["class", "style"],
  header: ["class", "style"],
  hr: ["class", "style"],
  i: ["class", "style"],
  img: ["src", "alt", "title", "width", "height", "class", "style"],
  ins: ["datetime", "class", "style"],
  li: ["class", "style"],
  mark: ["class", "style"],
  nav: ["class", "style"],
  ol: ["class", "style"],
  p: ["class", "style"],
  pre: ["class", "style"],
  s: ["class", "style"],
  section: ["class", "style"],
  small: ["class", "style"],
  span: ["class", "style"],
  sub: ["class", "style"],
  sup: ["class", "style"],
  strong: ["class", "style"],
  table: ["width", "border", "align", "valign", "class", "style"],
  tbody: ["align", "valign", "class", "style"],
  td: ["width", "rowspan", "colspan", "align", "valign", "class", "style"],
  tfoot: ["align", "valign", "class", "style"],
  th: ["width", "rowspan", "colspan", "align", "valign", "class", "style"],
  thead: ["align", "valign", "class", "style"],
  tr: ["rowspan", "align", "valign", "class", "style"],
  tt: ["class", "style"],
  u: ["class", "style"],
  ul: ["class", "style"]
}
export default whiteList